import inscriptionVendeur from "./inscriptionVendeur"
export default inscriptionVendeur;
